import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTitulos } from '../actions/titulosActions';
import { createCertificado } from '../actions/socioActions';
import QRCode from 'qrcode';

// Guardia global por sesiÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n (evita mÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºltiples creates por socio/tipo si hay remounts)
const emittedSessionKeys = new Set();

const CertificadoRegistro = ({ show, handleClose, socio }) => {
  const dispatch = useDispatch();
  const { titulos } = useSelector(state => state.titulo);

  const [titulosReady, setTitulosReady] = useState(false);
  const gradoTexto = useMemo(() => {
    if (!titulosReady) return 'ingeniero';

    const grados = Array.isArray(titulos)
      ? titulos.map(t => Number(t.grado)).filter(Number.isFinite)
      : [];

    if (grados.length > 0 && grados.every(g => g === 10)) return 'tecnico';
    if (grados.includes(1)) return 'ingeniero';
    return 'ingeniero';
  }, [titulos, titulosReady]);
  const [isSaving, setIsSaving] = useState(false);
  const [certUrl, setCertUrl] = useState('');
  const [certCodigo, setCertCodigo] = useState('');
  const [pdfDataUri, setPdfDataUri] = useState('');

  // 1) Cargar titulos
  useEffect(() => {
    const sid = socio?.id || socio?._id;
    if (!show || !sid) return;

    setTitulosReady(false);
    dispatch(fetchTitulos(sid)).finally(() => {
      setTitulosReady(true);
    });
  }, [dispatch, show, socio]);


  // 3) Limpiar al cerrar
  useEffect(() => {
    if (!show) {
      setIsSaving(false);
      setCertUrl('');
      setCertCodigo('');
      setTitulosReady(false);
      setPdfDataUri('');
      const container = document.getElementById('pdf-preview');
      if (container) container.innerHTML = '';
    }
  }, [show]);

  const loadImage = async (url) => {
    const res = await fetch(url);
    return res.arrayBuffer();
  };

  const extractCodeFromUrl = (url) => {
    try {
      if (!url) return '';
      const u = new URL(url, window.location.origin);
      const path = u.pathname.replace(/\/+$/,''); // sin trailing slash
      const segs = path.split('/');
      const last = segs[segs.length - 1];
      return decodeURIComponent(last || '');
    } catch {
      // fallback manual
      const clean = (url || '').split('?')[0].split('#')[0];
      const parts = clean.split('/');
      return decodeURIComponent(parts.pop() || '');
    }
  };

  // Payload JSON para el QR cuando no hay URL pÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºblica
  const buildQRPayload = useCallback(() => {
    const hoyISO = new Date().toISOString().slice(0, 10);
    const titulosLimpios = Array.isArray(titulos)
      ? titulos.map(t => ({
          grado: t.grado,
          titulo: t.titulo || t.nombre || '',
          universidad: t.suniv || t.universidad || socio?.suniv || '',
          nrotit: t.nrotit || socio?.nrotit || '',
          fecha: t.fecha || t.fechatitulo || ''
        }))
      : [];

    return JSON.stringify({
      entidad: 'CIAB - Filial Tarija',
      tipo: 'Certificado de Afiliacion',
      generado: hoyISO,
      socio: {
        id: socio?.id || socio?._id,
        codreg: socio?.codreg,
        ci: socio?.ci,
        nombres: socio?.nombres,
        apPat: socio?.apPat,
        apMat: socio?.apMat,
        genero: socio?.genero,
        gradoTexto,
        nrotit: socio?.nrotit,
        suniv: socio?.suniv,
        telefono: socio?.telefono || socio?.celular || '',
        email: socio?.email || socio?.correo || '',
      },
      titulos: titulosLimpios
    });
  }, [socio, gradoTexto, titulos]);

  // 4) GRABAR en backend y devolver URL/CÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã¢â‚¬Å“DIGO
  const emitirYObtenerUrl = useCallback(async () => {
    const socioId = socio?.id || socio?._id;
    if (!socioId) {
      toast.error('Faltan datos del socio (id).');
      return { url: null, codigo: null };
    }

    try {
      setIsSaving(true);

      const data = await dispatch(
        createCertificado({
          socio,
          tipoUi: 'REGISTRO',
          titulos,
          gradoTexto
        })
      );

      const hint = data?.public_url_hint || '';
      const codigo = data?.certificado?.codigo || data?.codigo || extractCodeFromUrl(hint) || '';

      if (!codigo) {
        toast.error('No se pudo obtener el codigo del certificado para el QR.');
        return { url: null, codigo: null };
      }

      const urlFront = `${window.location.origin}/ver-certificado/${encodeURIComponent(codigo)}`;
      setCertCodigo(codigo);
      setCertUrl(urlFront);
      toast.success('Certificado creado correctamente.');
      return { url: urlFront, codigo };
    } catch (e) {
      console.error('[emitirYObtenerUrl] Error:', e);
      toast.error('No se pudo registrar el certificado en el servidor.');
      return { url: null, codigo: null };
    } finally {
      setIsSaving(false);
    }
  }, [dispatch, socio, titulos, gradoTexto]);

  // 5) Generar PDF y mostrarlo (recibe cÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³digo explÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­cito)
  const generatePDF = useCallback(async (qrContentParam, codigoParam) => {
    try {
      const pdfDoc = await PDFDocument.create();
      const page = pdfDoc.addPage([612, 792]);

      const marginLeft = 113;
      const marginRight = 80;
      const maxWidth = page.getWidth() - marginLeft - marginRight;

      const logoBytes = await loadImage(process.env.PUBLIC_URL + '/assets/cabeceraciab.png');
      const pieBytes  = await loadImage(process.env.PUBLIC_URL + '/assets/pieciab.png');

      const logoImage = await pdfDoc.embedPng(logoBytes);
      const pieImage  = await pdfDoc.embedPng(pieBytes);

      const logoDims = logoImage.scale(0.35);
      const pieDims  = pieImage.scale(0.35);

      // Cabecera
      page.drawImage(logoImage, {
        x: marginLeft - 10,
        y: page.getHeight() - logoDims.height - 40,
        width: logoDims.width,
        height: logoDims.height,
      });

      // Pie
      page.drawImage(pieImage, {
        x: marginLeft - 10,
        y: 20,
        width: pieDims.width,
        height: pieDims.height,
      });

      const font     = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

      const pdfText = (value) => (value ?? '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/Âº/g, 'o')
        .replace(/Â°/g, 'o')
        .replace(/â€“|â€”/g, '-')
        .replace(/[^\x09\x0A\x0D\x20-\x7E]/g, '');

      const today = new Date();
      const day   = today.getDate();
      const month = today.toLocaleString('es-ES', { month: 'long' });
      const year  = today.getFullYear();
      const ella  = socio.genero === 'F' ? 'la' : 'el';
      const habi  = socio.genero === 'F' ? 'habilitada' : 'habilitado';
      const insc  = socio.genero === 'F' ? 'inscrita' : 'inscrito';
      const acti  = socio.genero === 'F' ? 'activa' : 'activo';

      // TÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­tulo
      const title = 'CERTIFICADO DE AFILIACION';
      const titleWidth = fontBold.widthOfTextAtSize(pdfText(title), 16);
      const titleY = page.getHeight() - logoDims.height - 80;
      page.drawText(pdfText(title), {
        x: (page.getWidth() - titleWidth) / 2,
        y: titleY,
        size: 16,
        font: fontBold,
        color: rgb(0, 0, 0),
      });

      // CÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³digo (usa el param, luego estado, luego lo extrae de la URL)
      const codeToRender = codigoParam || certCodigo || extractCodeFromUrl(certUrl) || '-';
      const codeText = `Codigo: ${codeToRender}`;
      const codeWidth = font.widthOfTextAtSize(pdfText(codeText), 12);
      const codeY = titleY - 18;
     /* page.drawText(codeText, {
        x: (page.getWidth() - codeWidth) / 2,
        y: codeY,
        size: 12,
        font,
        color: rgb(0, 0, 0),
      });*/
      const texts = [
        { type: 'text', value: 'El Colegio de Ingenieros Agronomos y Profesionales de Ciencias Agropecuarias de Bolivia - CIAB Filial Tarija.' },
        { type: 'fragmented', parts: [{ text: 'Certifica:', bold: true }]},
        { type: 'fragmented', parts: [
          { text: `Que, ${ella} ${gradoTexto}: `, bold: false },
          { text: `${socio.apPat} ${socio.apMat} ${socio.nombres}`, bold: true },
          { text: `, con C.I. ${socio.ci}, Titulo en Provision Nacional Nro ${socio.nrotit}, ${socio.suniv}, se encuentra legalmente ${insc} y ${acti} en el CIAB - FILIAL TARIJA, con el registro ${socio.codreg}, encontrandose ${habi} para ejercer la profesion de acuerdo a la Ley Nro 37014 del ejercicio profesional del Ingeniero Agronomo.`, bold: false }
        ]},
        { type: 'text', value: 'El presente certificado tiene una validez de 60 dias.' },
        { type: 'text', value: 'Es cuanto certificamos en honor a la verdad y para los fines consiguientes del interesado.' },
        { type: 'textRight', value: `Tarija, ${day} de ${month.charAt(0).toUpperCase() + month.slice(1)} de ${year}` },
      ];

      let y = page.getHeight() - logoDims.height - 120;

      const wrapText = (text, fnt, size = 12) => {
        const cleanText = pdfText(text).replace(/\s+/g, ' ').trim();
        const words = cleanText.split(' ').filter(Boolean);
        const lines = [];
        let line = '';

        words.forEach(word => {
          const candidate = line ? `${line} ${word}` : word;
          if (fnt.widthOfTextAtSize(candidate, size) > maxWidth && line) {
            lines.push(line);
            line = word;
          } else {
            line = candidate;
          }
        });

        if (line) lines.push(line);
        return lines;
      };

      const addTextBlock = (text, yPos, fnt = font, size = 12, lineHeight = 16) => {
        const lines = wrapText(text, fnt, size);
        lines.forEach(line => {
          page.drawText(line, {
            x: marginLeft,
            y: yPos,
            size,
            font: fnt,
            color: rgb(0, 0, 0),
          });
          yPos -= lineHeight;
        });
        return yPos;
      };

      const addTextRightAligned = (text, yPos, fnt = font, size = 12, lineHeight = 16) => {
        const lines = wrapText(text, fnt, size);
        lines.forEach(line => {
          page.drawText(line, {
            x: page.getWidth() - marginRight - fnt.widthOfTextAtSize(line, size),
            y: yPos,
            size,
            font: fnt,
            color: rgb(0, 0, 0),
          });
          yPos -= lineHeight;
        });
        return yPos;
      };

      // Cuerpo (formato intacto)
      texts.forEach(textObj => {
        if (textObj.type === 'text') {
          y = addTextBlock(textObj.value, y, font);
          y -= 6;
        } else if (textObj.type === 'fragmented') {
          y = addTextBlock(textObj.parts.map(part => part.text).join(''), y, font);
          y -= 6;
        } else if (textObj.type === 'textRight') {
          addTextRightAligned(textObj.value, y, font);
        }
      });

      // === QR: abajo-izquierda ===
      const contentForQR = qrContentParam || certUrl;
      if (!contentForQR) {
        toast.error('No se pudo generar el QR: falta la URL publica del certificado.');
        return;
      }
      const qrDataUrl = await QRCode.toDataURL(contentForQR, {
        errorCorrectionLevel: 'M',
        margin: 1,
        width: 180,
      });

      const qrRes = await fetch(qrDataUrl);
      const qrBytes = await qrRes.arrayBuffer();
      const qrImage = await pdfDoc.embedPng(qrBytes);

      const qrScale = 140 / qrImage.width;
      const qrDims = qrImage.scale(qrScale);

      const padding = 16;
      const qrX = marginLeft - 10;
      const qrY = 20 + pieDims.height + padding;

    /*  page.drawText(pdfText('Escanear para verificar'), {
        x: qrX,
        y: qrY + qrDims.height + 8,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
*/
      page.drawImage(qrImage, {
        x: qrX,
        y: qrY,
        width: qrDims.width,
        height: qrDims.height,
      });

      const dataUri = await pdfDoc.saveAsBase64({ dataUri: true });
      setPdfDataUri(dataUri);

      const container = document.getElementById('pdf-preview');
      if (container) container.innerHTML = `<iframe width='100%' height='600px' src='${dataUri}'></iframe>`;
    } catch (error) {
      console.error(error);
      toast.error('Error al generar el PDF. Por favor verifique los datos del socio...');
    }
  }, [buildQRPayload, socio?.genero, certUrl, certCodigo, gradoTexto, socio]);

  // Al abrir modal: crear una sola vez por sesiÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n y generar PDF
  useEffect(() => {
    if (!show || !socio || !titulosReady) return;
    const socioId = socio?.id || socio?._id;
    if (!socioId) return;

    const key = `REGISTRO:${socioId}`;
    if (emittedSessionKeys.has(key)) {
      // Si ya existe en esta sesiÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n, re-genera PDF con lo que haya
      const code = certCodigo || extractCodeFromUrl(certUrl) || '';
      (async () => {
        await generatePDF(certUrl || undefined, code || undefined);
      })();
      return;
    }

    emittedSessionKeys.add(key);

    (async () => {
      const { url, codigo } = await emitirYObtenerUrl();
      await generatePDF(url || undefined, codigo || undefined);
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, socio, titulosReady, gradoTexto]); // deps minimas para esperar titulos

  return (
    <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title>Certificado de Afiliacion</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div id="pdf-preview"></div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isSaving}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CertificadoRegistro;
